import type { IntegrationProviderId } from '../../../types/integration'

export type ExternalLinkProviderDefinition = {
  providerId: IntegrationProviderId
  label: string
  color: string
  entityTypes: Array<'GOAL' | 'TASK' | 'SUBTASK' | 'CHECKLIST_ITEM' | 'MEETING'>
  actions: Array<'PUSH' | 'PULL' | 'OPEN'>
}

export const providerRegistry: Partial<Record<IntegrationProviderId, ExternalLinkProviderDefinition>> = {
  NOTION: {
    providerId: 'NOTION',
    label: 'Notion',
    color: '#111111', // mosaic-keep: data (third-party brand color)
    entityTypes: ['GOAL', 'TASK', 'SUBTASK', 'CHECKLIST_ITEM'],
    actions: ['PUSH', 'PULL', 'OPEN'],
  },
  JIRA: {
    providerId: 'JIRA',
    label: 'Jira',
    color: '#1868db', // mosaic-keep: data (third-party brand color)
    entityTypes: ['GOAL', 'TASK', 'SUBTASK', 'CHECKLIST_ITEM'],
    actions: ['PUSH', 'PULL', 'OPEN'],
  },
  GOOGLE_CALENDAR: {
    providerId: 'GOOGLE_CALENDAR',
    label: 'Google Calendar',
    color: '#0284c7', // mosaic-keep: data (third-party brand color)
    entityTypes: ['MEETING', 'GOAL', 'TASK', 'SUBTASK', 'CHECKLIST_ITEM'],
    actions: ['PUSH', 'PULL', 'OPEN'],
  },
  GOOGLE_SHEETS: {
    providerId: 'GOOGLE_SHEETS',
    label: 'Google Sheets',
    color: '#0f9d58', // mosaic-keep: data (third-party brand color)
    entityTypes: ['CHECKLIST_ITEM', 'TASK', 'GOAL'],
    actions: ['PUSH', 'PULL', 'OPEN'],
  },
  SLACK: {
    providerId: 'SLACK',
    label: 'Slack',
    color: '#4A154B', // mosaic-keep: data (third-party brand color)
    entityTypes: ['TASK', 'CHECKLIST_ITEM', 'GOAL'],
    actions: ['PUSH', 'OPEN'],
  },
  ZOOM: {
    providerId: 'ZOOM',
    label: 'Zoom',
    color: '#2d8cff', // mosaic-keep: data (third-party brand color)
    entityTypes: ['MEETING'],
    actions: ['PUSH', 'OPEN'],
  },
  DROPBOX: {
    providerId: 'DROPBOX',
    label: 'Dropbox',
    color: '#0061ff', // mosaic-keep: data (third-party brand color)
    entityTypes: [],
    actions: ['OPEN'],
  },
  GITHUB: {
    providerId: 'GITHUB',
    label: 'GitHub',
    color: '#24292f', // mosaic-keep: data (third-party brand color)
    entityTypes: ['TASK'],
    actions: ['PUSH', 'PULL', 'OPEN'],
  },
  FIGMA: {
    providerId: 'FIGMA',
    label: 'Figma',
    color: '#a259ff', // mosaic-keep: data (third-party brand color)
    entityTypes: ['TASK'],
    actions: ['PUSH', 'OPEN'],
  },
}
